<template>
  <div
    ref="LvDropdownSingleCategorySelect"
    class="lv-dropdown-single-category-select"
  >
    <LvText
      v-if="title"
      h6
      bold
    >
      {{ $t(title) }}<LvText v-if="required" red>*</LvText>
    </LvText>
    <div
      v-click-outside="$_onCloseMenu"
      class="lv-dropdown-single-category-select__content-wrap"
    >
      <div
        class="lv-dropdown-single-category-select__content mb-8"
        :class="{
          wide,
          narrow,
          outline,
          disabled,
          error: validationErrors.length > 0
        }"
      >
        <i
          v-if="leadingIcon"
          class="icon leading-icon"
          :class="leadingIcon"
        />
        <button
          class="input-button"
          @click="$_onToggleMenu"
        >
          <LoadingAnimate v-if="isLoadingItems" primary/>
          <LvFlexBox v-else>
            <p class="select">
              {{ _selectItems }}
            </p>
            <i
              v-if="!disabled && value"
              class="cancel-icon icon-cancel"
              @click.stop="$_onChangeValue('')"
            />
          </LvFlexBox>
        </button>
        <i
          v-if="outline || disabled"
          class="icon trailing-icon outline icon-chevron-up"
          :class="{show: dropdownMenuShow}"
        />
        <i
          v-else-if="!outline && !dropdownMenuShow"
          class="icon trailing-icon icon-arrow-drop-down-circle"
        />
        <i
          v-else-if="!outline && dropdownMenuShow"
          class="icon trailing-icon icon-arrow-drop-up-circle"
        />
        <transition mode="out-in">
          <div
            v-if="dropdownMenuShow && !isActive.create"
            class="lv-dropdown-single-category-select__menu"
            :class="{
              'drop-up': scroll !== undefined ? isDropUp : false,
            }"
          >
            <div v-if="!isLoadingItems" class="search-tool">
              <SearchInput
                :value="search.value"
                :textLabel="search.textLabel"
                :placeholder="search.placeholder"
                @input="$_search"
              />
            </div>
            <DotLoading v-if="isLoadingItems" />
            <perfect-scrollbar v-else class="ps lv-dropdown-single-category-select__scrollable-content">
              <div
                v-for="(item,itemKey) in _menuItems"
                :key="itemKey"
                class="classification-list"
              >
                <div
                  v-if="item.title"
                  class="classification-title"
                >
                  <span>{{ $t(item.title) }}</span>
                </div>
                <div class="classification-subtitle">
                  <RadioButton
                    isNarrow
                    :value="value"
                    :rules="rules"
                    :disable="disabled"
                    :radioButtonItem="{buttonItems: item.buttonItems}"
                    @input="$_onChangeValue($event)"
                  />
                  <div v-if="item.menu.length==0">
                    -
                  </div>
                </div>
              </div>
            </perfect-scrollbar>
            <div
              v-if="_hasManageScope && !isLoadingItems"
              class="lv-dropdown-single-category-select__menu_btns"
            >
              <div
                v-if="scope.isCreatable"
                class="lv-dropdown-single-category-select__menu_btn"
                @click="$_onOpenCreateField()"
              >
                <i class="icon-add-circle lv-dropdown-single-category-select__menu_btn-icon" />
                <p class="lv-dropdown-single-category-select__menu_btn-text">
                  {{ _createBtnText }}
                </p>
              </div>
              <div
                v-if="_hasEditScope"
                class="lv-dropdown-single-category-select__menu_btn"
                @click="$_onOpenManagePopup()"
              >
                <i class="icon-edit lv-dropdown-single-category-select__menu_btn-icon" />
                <p class="lv-dropdown-single-category-select__menu_btn-text">
                  {{ _manageBtnText }}
                </p>
              </div>
            </div>
          </div>
        </transition>
        <transition mode="out-in">
          <ValidationObserver
            v-if="isActive.create"
            ref="createObserve"
            class="lv-dropdown-single-category-select__menu "
            :class="{show: isActive.create, 'drop-up': scroll !== undefined ? isDropUp : false,}"
          >
            <div class="menu-title">
              <i
                class="icon-arrow-left menu-title_icon"
                @click="$_onCloseCreateField()"
              />
              <p class="menu-title_text">
                {{ _createBtnText }}
              </p>
            </div>
            <div class="create-content">
              <LlState
                v-for="(field,fieldKey) in createFields"
                :key="fieldKey"
                v-model="createData[fieldKey]"
                required
                :type="field.type"
                :title="field.title"
                :rules="field.rules"
                :isRequired="field.required"
                :placeholder="field.placeholder"
              />
              <div class="btns">
                <div class="btn">
                  <WsButton001
                    outLine
                    narrow
                    @click="$_onCloseCreateField()"
                  >
                    {{ $t("取消") }}
                  </WsButton001>
                </div>
                <div class="btn">
                  <WsButton001
                    :isloading="isLoading.create"
                    @click="$_onSubmitCreate()"
                  >
                    {{ $t("送出") }}
                  </WsButton001>
                </div>
              </div>
            </div>
          </ValidationObserver>
        </transition>
      </div>
      <ValidationProvider
        v-slot="{ errors }"
        :rules="rules"
      >
        {{$_onSetValidationErrors(errors)}}
        <div
          v-if="errors.length > 0"
          class="invalid-text"
        >
          <i class="icon-warning invalid-icon" />
          <p
            v-for="(text_e,text_k) in errors"
            :key="text_k"
            class="text"
          >
            {{ $t(text_e) }}
          </p>
        </div>
        <input
          type="hidden"
          :value="value"
        >
      </ValidationProvider>
    </div>
    <PopUp
      unbottom
      :title="_manageBtnText"
      :popUpActive="isActive.management"
      @click="$_onCloseManagePopup()"
    >
      <LvPopupScrollContent
        :emptyTitle="_emptyTitle"
        :itemList="_customItemList"
        :isUpdatable="scope.isUpdatable"
        :isDeletable="scope.isDeletable"
        @edit-click="$_onOpenUpdatePopup($event)"
        @delete-click="$_onOpenDeletePopup($event)"
      />
    </PopUp>
    <PopUp
      unbottom
      :title="_deletePopupTitle"
      :isLoading="isLoading.deletePopup"
      :popUpActive="isActive.deletePopup"
      @click="$_onCloseDeletePopup()"
    >
      <LvText
        v-if="deletePopup.contentText"
        class="mb-4"
      >{{$t(deletePopup.contentText)}}</LvText>
      <div v-if="deletePopup.relatedModuleNumList && deletePopup.relatedModuleNumList.length">
        <LvText
          v-for="(item, itemIndex) in deletePopup.relatedModuleNumList"
          :key="itemIndex"
          class="mb-4"
        >{{$t(item)}}</LvText>
      </div>
      <LlCancelPopupContent>
        <template v-slot:buttons>
          <WsButton001
            outLine
            @click="$_onCloseDeletePopup()"
          >
            {{ isDeletable ? $t("取消") : $t("確定") }}
          </WsButton001>
          <WsButton001
            v-if="isDeletable"
            @click="$_onSubmitDelete()"
          >
            {{ $t("確定") }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
    <PopUp
      unbottom
      :clickOutsideClose="false"
      :title="$t(_updatePopupTitle)"
      :popUpActive="isActive.update"
      @click="$_onCloseUpdatePopup()"
    >
      <LlCancelPopupContent v-if="isActive.update">
        <LlState
          v-for="(field, fieldKey) in updateFields"
          :key="fieldKey"
          v-model="updateData[fieldKey]"
          :type="field.type"
          :rules="field.rules"
          :title="$t(field.title)"
          :isRequired="field.isRequired"
          :textLength="field.textLength"
        />
        <template v-slot:buttons>
          <WsButton001
            outLine
            @click="$_onCloseUpdatePopup()"
          >
            {{ $t("取消") }}
          </WsButton001>
          <WsButton001 @click="$_onSubmitUpdate()">
            {{ $t("送出") }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import S_scope from '@/service/api/v1/scope';
import H_common from '@/helpers/common';

extend('required', {
  ...required,
  message: '此項目為必填',
});
extend('nospace', {
  validate: (value) => {
    if (/\s/.test(value)) {
      return false;
    } else {
      return true;
    }
  },
  message: '不可為空格',
});
export default {
  directives: {
    ClickOutside,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    rules: {
      type: String,
    },
    value: {
      type: String,
    },
    selectValue: {
      type: Object,
      default() {
        return {};
      },
    },
    menuItems: {
      type: Array,
      default() {
        return [];
      },
    },
    leadingIcon: {
      type: String,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    title: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    createFields: {
      type: Object,
      default() {
        return {};
      },
    },
    createUrl: {
      type: String,
    },
    manageBtnText: {
      type: String,
    },
    createBtnText: {
      type: String,
    },
    label: {
      type: String,
    },
    scope: {
      type: Object,
      default() {
        return {
          isCreatable: false,
          isUpdatable: false,
          isDeletable: false,
        };
      },
    },
    updatePopupTitle: {
      type: String,
    },
    updateFields: {
      type: Object,
      default() {
        return {};
      },
    },
    deletePopupTitle: {
      type: String,
    },
    scroll: {
      type: Number,
    },
    isLoadingItems: {
      type: Boolean,
      default: false
    },
    setDeletePopupInfo: {
      type: Function,
    },
    isDeletable: {
      type: Boolean,
      default: true,
    },
  },
  data(){
    return {
      isLoading: {
        create: false,
        deletePopup: false,
      },
      dropdownMenuShow: false,
      createData: {},
      isActive: {
        create: false,
        management: false,
        deletePopup: false,
        update: false,
      },
      deleteData: {},
      updateData: {},
      search: {
        value: '',
        placeholder: this.$t('搜尋'),
        textLabel: this.$t('搜尋'),
      },
      searchItems:[],
      isDropUp: false,
      dropdownHeight: 0,
      dropdownTop: 0,
      windowHeight: 0,
      validationErrors: [],
      deletePopup: {
        contentText: '',
        relatedModuleNumList: [],
      },
    };
  },
  computed: {
    _menuItems(){
      return this.menuItems.map(item => {
        const buttonItems = item.menu.map(({text: textLabel, value: id}) => ({id, textLabel}));
        return {
          ...item,
          buttonItems: this.search.value
            ? buttonItems
              .filter(item => item.textLabel.toLowerCase()
              .includes(this.search.value.toLowerCase()))
            : buttonItems,
        };
      });
    },
    _placeholder() {
      return this.placeholder
        ? this.$t(this.placeholder)
        : this.$t('選擇');
    },
    _selectItems() {
      if (!this.value) return this._placeholder;
      const items = [];
      for (const item of this.menuItems) {
        if (item.menu && item.menu.length) {
          items.push(...item.menu);
        }
      }
      const selectedItem = items.find(item => item.value === this.value);
      return selectedItem ? selectedItem.text : this._placeholder;
    },
    _createBtnText() {
      return this.createBtnText
        ? this.$t(this.createBtnText)
        : this.$t(`新增${this.label}`);
    },
    _manageBtnText() {
      return this.manageBtnText
        ? this.$t(this.manageBtnText)
        : this.$t(`管理${this.label}`);
    },
    _updatePopupTitle() {
      return this.updatePopupTitle
        ? this.$t(this.updatePopupTitle)
        : this.$t(`編輯${this.label}`);
    },
    _deletePopupTitle() {
      return this.deletePopupTitle
        ? this.deletePopupTitle
        : `確定刪除嗎？`;
    },
    _hasManageScope() {
      const tarScopeList = [
        'isCreatable',
        'isUpdatable',
        'isDeletable',
      ]
      return S_scope.isScopeAvailable(tarScopeList, this.scope)
    },
    _hasEditScope() {
      const tarScopeList = [
        'isUpdatable',
        'isDeletable',
      ]
      return S_scope.isScopeAvailable(tarScopeList, this.scope)
    },
    _customItemList() {
      const customItemList = []
      for (const item of this.menuItems) {
        if (item.isCustom) {
          customItemList.push(...item.menu);
        }
      }
      return customItemList
    },
    _emptyTitle() {
      return '目前尚無資料';
    }
  },
  watch: {
    scroll() {
      this.$_getDropdownHeight();
      this.$_isDropUp();
    },
  },
  created() {
    window.addEventListener('resize', this.$_handleResize);
    window.addEventListener('resize', this.$_getDropdownHeight);
    window.addEventListener('resize', this.$_isDropUp);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_handleResize);
    window.removeEventListener('resize', this.$_getDropdownHeight);
    window.removeEventListener('resize', this.$_isDropUp);
  },
  mounted() {
    this.$_getDropdownHeight();
    this.$_isDropUp();
  },
  methods: {
    $_search($event){
      this.search.value = $event;
    },
    $_getCheckState(firstLayerId, secondLayerId) {
      return this.value[firstLayerId] && this.value[firstLayerId].includes(secondLayerId);
    },
    $_onToggleMenu() {
      if (this.disabled || this.isLoadingItems) return;
      this.dropdownMenuShow = !this.dropdownMenuShow;
      this.$emit('toggle', this.dropdownMenuShow);
    },
    $_onCloseMenu() {
      this.dropdownMenuShow = false;
      this.isActive.create = false;
      this.createData = {};
    },
    $_onOpenCreateField() {
      this.dropdownMenuShow = false;
      this.isActive.create = true;
      const createData = {}
      for (const key in this.createFields) {
        createData[key] = null
      }
      this.createData = createData
    },
    $_onCloseCreateField() {
      this.isActive.create = false;
      this.createData = {};
      this.dropdownMenuShow = true;
    },
    async $_onSubmitCreate() {
      this.isLoading.create = true;
      const isValidate = await this.$refs.createObserve.validate();
      if (!isValidate) {
        return;
      }
      try {
        await this.$axios.post(this.createUrl, this.createData);
        this.$emit('created')
      } catch (err) {
        alert(this.$t('新增發生錯誤'));
      } finally {
        this.isLoading.create = false;
      }
      this.$_onCloseMenu();
    },
    $_onOpenManagePopup() {
      this.isActive.management = true
    },
    $_onCloseManagePopup() {
      this.isActive.management = false
    },
    async $_onOpenDeletePopup($event) {
      this.deleteData = this.$_getTarItem($event);
      this.isActive.deletePopup = true;
      if (this.setDeletePopupInfo) {
        this.isLoading.deletePopup = true;
        const {contentText, relatedModuleNumList} = await this.setDeletePopupInfo(this.deleteData);
        this.deletePopup = {
          contentText,
          relatedModuleNumList,
        };
        this.isLoading.deletePopup = false;
      }
      this.$emit('active-delete-popup', {deleteData: this.deleteData, deletePopup: this.deletePopup});
    },
    $_onCloseDeletePopup() {
      this.deleteData = {}
      this.isActive.deletePopup = false
    },
    $_onOpenUpdatePopup($event) {
      const tarItem = this.$_getTarItem($event)
      const updateData = {
        value: $event,
      }
      for (const key in this.updateFields) {
        const getValueKey = this.updateFields[key].getValueKey
          ? this.updateFields[key].getValueKey
          : key
        updateData[key] = tarItem[getValueKey]
      }
      this.updateData = updateData
      this.isActive.update = true
    },
    $_onCloseUpdatePopup() {
      this.updateData = {}
      this.isActive.update = false
    },
    $_onSubmitDelete() {
      this.$emit('delete', this.deleteData)
      this.$_onCloseDeletePopup()
    },
    $_onSubmitUpdate() {
      this.$emit('update', this.updateData)
      this.$_onCloseUpdatePopup()
    },
    $_getTarItem(value) {
      let tarItem = null
      this.menuItems.forEach(item => {
        if (item.isCustom) {
          const tarItemIndex = item.menu.findIndex(subItem => subItem.value === value)
          if (tarItemIndex >= 0) {
            tarItem = item.menu[tarItemIndex]
          }
        }
      })
      return tarItem
    },
    $_handleResize() {
      this.windowHeight = window.innerHeight;
    },
    $_getDropdownHeight() {
      const {height, y} = H_common.getComponentHeightAndY(this.$refs.LvDropdownSingleCategorySelect);
      this.dropdownHeight = height;
      this.dropdownTop = y;
    },
    $_isDropUp() {
      this.isDropUp = H_common.isDropUp(this.dropdownHeight, this.dropdownTop, 350, 350);
    },
    $_onSetValidationErrors(errors) {
      this.validationErrors = errors;
      return null;
    },
    $_onChangeValue($event) {
      if (this.disable) return;
      this.$emit('input', $event);
    }
  },
};
</script>